module.exports = __webpack_public_path__ + "img/bicycle-door.2891531b.jpg";